import React, { useContext, useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import SendIcon from '@mui/icons-material/Send';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import { Link } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const ModuleCard = ({ module, index, handleUpdateButtonClick, handleDeleteButtonClick, url, courseId, handleModuleDelete, handleTitleUpdate, handleTitleUpdateChange, moduleDeleteModalOpen, moduleUpdateModalOpen, moduleUpdateTitle, setModuleUpdateModalOpen, setModuleDeleteModalOpen
}) => {
  return (
    <Draggable draggableId={module._id} index={index} className="w-full">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className="w-4/5 md:w-full flex flex-col items-center justify-center"
        >
          <div className="rounded overflow-hidden shadow-lg md:w-4/5 w-full bg-white">
            <div key={module?._id} className="px-6 py-4 flex flex-col items-center justify-between border-b gap-4">

              {/* Row 1 - Title */}
              <div className="w-full flex items-center justify-between border-b pb-2">
                <h3 className="font-bold text-lg sm:text-xl text-gray-800">{module?.title}</h3>
              </div>

              {/* Row 2 - Buttons */}
              <div className="w-full flex flex-wrap gap-3 justify-center items-center md:justify-end border-b pt-2 pb-4">
                {/* Edit Module Button */}
                <button
                  className="bg-blue-500 hover:bg-blue-400 text-white font-semibold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded"
                  onClick={() => handleUpdateButtonClick(module.title, module._id)}
                >
                  Title
                </button>

                <Modal
                  open={moduleUpdateModalOpen}
                  onClose={() => setModuleUpdateModalOpen(false)}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      Enter Chapter Title
                    </Typography>
                    <TextField
                      className="w-full mt-3"
                      id="outlined-basic"
                      label="Chapter Title"
                      variant="outlined"
                      onChange={handleTitleUpdateChange}
                      value={moduleUpdateTitle}
                    />
                    <div className="flex flex-col sm:flex-row w-full justify-end items-center gap-2 mt-4">
                      <Button variant="contained" onClick={handleTitleUpdate}>SAVE</Button>
                      <Button variant="contained" onClick={() => setModuleUpdateModalOpen(false)}>Close</Button>
                    </div>
                  </Box>
                </Modal>

                {/* Delete Module Button */}
                <button
                  className="bg-blue-500 hover:bg-blue-400 text-white font-semibold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded"
                  onClick={() => handleDeleteButtonClick(module._id)}
                >
                  Delete
                </button>

                <Modal
                  open={moduleDeleteModalOpen}
                  onClose={() => setModuleDeleteModalOpen(false)}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      Are you sure you want to delete this chapter? All the associated sections and PDF files will be deleted.
                    </Typography>
                    <div className="flex flex-col sm:flex-row w-full justify-end items-center gap-2 mt-4">
                      <Button variant="contained" onClick={handleModuleDelete}>Delete</Button>
                      <Button variant="contained" onClick={() => setModuleDeleteModalOpen(false)}>Cancel</Button>
                    </div>
                  </Box>
                </Modal>

                {/* View Chapter Button */}
                <Link to={`${url}/courses/${courseId}/${module._id}/sections/create`}>
                  <button className="bg-blue-500 hover:bg-blue-400 text-white font-semibold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded">
                    View Chapter
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

      )}
    </Draggable>
  );
};

export default ModuleCard;
